import {
  Button,
  Collapse,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AccountingAnanlyticsBookingPreview from "./AccountingAnalyticsBookingPreview";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useState } from "react";
import {
  CopyAll,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import excelGenerator from "../../../utils/excel/excelGenerator";
import accountFormatter from "../../../utils/excel/formatters/accountFormatter";

const SingleDateAccountViewer = ({ date, bookings, file,types }) => {
  const [isOpen, setIsOpen] = useState(bookings.length <= 4);
  const [copyText, setCopyText] = useState("Copy");
  const [downloadText, setDownloadText] = useState("Download");

  const onCopyText = (isDownload) => {
    excelGenerator({date:bookings}, accountFormatter, file, isDownload);
    isDownload ? setDownloadText("Downloaded") : setCopyText("Copied");
    setTimeout(() => {
      isDownload ? setDownloadText("Download") : setCopyText("Copy");
    }, 2000);
  };

  const onToggle = () => {
    setIsOpen((p) => !p);
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          flexGrow: 1,
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Button
          onClick={onToggle}
          disableRipple
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            textTransform: "none",
          }}
        >
          <Typography
            variant="h6"
            color="primary.main"
            sx={{ fontSize: "14px" }}
          >
            {date}
          </Typography>

          {isOpen ? (
            <KeyboardArrowUp sx={{ marginLeft: "20px" }} />
          ) : (
            <KeyboardArrowDown sx={{ marginLeft: "20px" }} />
          )}
        </Button>

        <div
        style={{
          marginRight:"30px"
        }}        >
          <Tooltip title={downloadText} placement="left">
            <IconButton
              sx={{
                marginRight: "20px",
              }}
              onClick={() => {
                onCopyText(true);
              }}
            >
              <ArrowDownwardIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={copyText} placement="right">
            <IconButton
              onClick={() => {
                onCopyText(false);
              }}
            >
              <CopyAll />
            </IconButton>
          </Tooltip>
        </div>
      </Stack>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <div style={{ marginLeft: "10px" }}>
          {bookings.map((book) => {
            return (
              <AccountingAnanlyticsBookingPreview
                key={book.bookingId}
                booking={book}
                types={types}
              />
            );
          })}
        </div>
      </Collapse>
    </>
  );
};

export default SingleDateAccountViewer;
